import { gql, useQuery } from '@apollo/client';

import { PlaceVoiceSettingsQl, VoiceConfigurationQl } from '../graphql';

/* eslint-disable max-len */
export const fallbackVoiceConfiguration: VoiceConfigurationQl[] = [
  {
    voiceType: 'ElevenLabs-Rachel',
    language: 'en',
    service: 'ElevenLabs',
    imgUrl:
      'https://storage.cloud.google.com/media.beta.numberai.com/voice_avatars/voiceAvatarFF.svg',
    voiceAudio:
      'https://storage.googleapis.com/media.beta.numberai.com/numa/MK2BA-8637cd1edec84905801879e1dadd3d5f.mp3',
  },
  {
    voiceType: 'ElevenLabs-Josh',
    language: 'en',
    service: 'ElevenLabs',
    imgUrl:
      'https://storage.cloud.google.com/media.beta.numberai.com/voice_avatars/voiceAvatarFM.svg',
    voiceAudio:
      'https://storage.googleapis.com/media.beta.numberai.com/numa/2SF9L-7c4feb85c90f4592aba30eedfe2522d9.mp3',
  },
  {
    voiceType: 'ElevenLabs-Natasha',
    language: 'en',
    service: 'ElevenLabs',
    imgUrl:
      'https://storage.cloud.google.com/media.beta.numberai.com/voice_avatars/voiceAvatarPF.svg',
    voiceAudio:
      'https://storage.googleapis.com/media.beta.numberai.com/numa/ElevenLabs_2023-12-22T03_03_02_Natasha_gen_s50_sb75_t2.mp3',
  },
  {
    voiceType: 'ElevenLabs-Adam',
    language: 'en',
    service: 'ElevenLabs',
    imgUrl:
      'https://storage.cloud.google.com/media.beta.numberai.com/voice_avatars/voiceAvatarPM.svg',
    voiceAudio:
      'https://storage.googleapis.com/media.beta.numberai.com/numa/K96N7-48437b0487fe4ad199e822c667708cd7.mp3',
  },
  {
    voiceType: 'ElevenLabs-Antoni',
    language: 'en',
    service: 'ElevenLabs',
    imgUrl:
      'https://storage.cloud.google.com/media.beta.numberai.com/voice_avatars/voiceAvatarSM.svg',
    voiceAudio:
      'https://storage.googleapis.com/media.beta.numberai.com/numa/B03I0-c54d8b7f0f0c49c198b2ec8eebe58c97.mp3',
  },
  {
    voiceType: 'ElevenLabs-Maya',
    language: 'en',
    service: 'ElevenLabs',
    imgUrl:
      'https://storage.cloud.google.com/media.beta.numberai.com/voice_avatars/voiceAvatarSF.svg',
    voiceAudio:
      'https://storage.googleapis.com/media.beta.numberai.com/numa/ElevenLabs_2023-12-22T03_03_18_Maya_gen_s50_sb75_t2.mp3',
  },
];

export const getVoiceConfigurationsQuery = gql`
  query getVoiceConfigurations($placeId: String!) {
    voiceConfigurations(placeId: $placeId) {
      voiceType
      language
      service
      imgUrl
      voiceAudio
    }
  }
`;

export const getPlaceVoiceSettingsQuery = gql`
  query getPlaceVoiceSettings($placeId: String!) {
    placeVoiceSettings(placeId: $placeId) {
      id
      voice
      voiceSpanish
      voiceFrench
      speechLanguage
      allowedSpeechLanguages
    }
  }
`;

export const useGetVoiceConfigurations = (placeId: string) => {
  const { data, loading, error } = useQuery<
    { voiceConfigurations: VoiceConfigurationQl[] },
    { placeId: string }
  >(getVoiceConfigurationsQuery, {
    variables: { placeId },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const configurations = data?.voiceConfigurations || [];

  return {
    data,
    loading,
    error,
    // Return fallback configurations if the API returns an empty array
    voiceConfigurations: configurations.length
      ? configurations
      : fallbackVoiceConfiguration,
  };
};

export const useGetPlaceVoiceSettings = (placeId: string) => {
  const { data, loading, error } = useQuery<
    { placeVoiceSettings: PlaceVoiceSettingsQl },
    { placeId: string }
  >(getPlaceVoiceSettingsQuery, {
    variables: { placeId },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    data,
    loading,
    error,
    placeVoiceSettings: data?.placeVoiceSettings,
  };
};
